<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!-- <el-button type="primary" @click="CreateRole()" size="mini">新建权限组</el-button> -->
      </div>
      <h3 class="title">固定人员设置</h3>
    </div>
    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="设置项目" width="200">
      </el-table-column>
      <el-table-column label="设置人员">
        <template slot-scope="scope">
          <user-info v-for="user,j in scope.row.users" key="j" style="display:inline-block;width:auto;margin-right:10px;"
            :userData='user'></user-info>
          <el-button size="mini" @click="addUsers(scope.row)" type="primary">更改人员</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 更改的User
        form: {
          id: '',
          userIds: '',
        },
      }
    },
    mounted() {
      this.getLists()
    },
    components: {
      UserInfo,
    },
    methods: {
      updateNodeUser() {
        ajax.post('/sys/node/user/edit', this.form, (res) => {
          this.getLists()
        })
      },

      // 选择更换项目/款项负责人
      addUsers(row) {
        // console.log(row)
        this.form.id = row.id
        let _sr = []
        if (row.users.length > 0) {
          _sr = row.users
        }
        console.log(_sr)

        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', false)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      getLists() {
        ajax.get('/sys/node/user/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      contactSelectArr() {
        console.log(this.contactSelectArr.length)
        if (this.contactSelectArr.length < 1) {
          return
        }

        this.form.userIds = this.contactSelectArr.map(item => item.id).join()
        // console.log(this.form.userIds)
        // if (this.form.userIds) {
          this.updateNodeUser()
        // }
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/set/nodeUserList.vue